// extracted by mini-css-extract-plugin
module.exports = {"collaboratorColumn":"TableListBody_collaboratorColumn__1_hxL"};